<template>
  <div class="policies">
    <div class="table">
      <div class="table__header box box--default">

        <div class="table__label table__label--small"> 
            {{ $t(`offersTable.${"startDate"}`) }} 
        </div>
        <div class="table__label table__label--medium"> 
            {{ $t(`offersTable.${"type"}`) }} 
        </div>
        <div class="table__label table__label--small"> 
            {{ $t(`offersTable.${"status"}`) }} 
        </div>
         <div class="table__label table__label--medium"> 
            {{ $t(`offersTable.${"agent"}`) }} 
        </div>
         <div class="table__label table__label--medium"> 
            {{ $t(`offersTable.${"assignedTo"}`) }} 
        </div>
        <div class="table__label table__label--medium"> 
            {{ $t(`offersTable.${"sentDate"}`) }} 
        </div>
         <div class="table__label table__label--smaller"> 
            {{ $t(`offersTable.${"file"}`) }} 
        </div>
        <div class="table__label table__label--small table__label--last"></div>
      </div>

      <div class="table__body"> 
        <Loading v-if="detailsLoading" />
        <template v-else>
          <div v-if="!customerOffers.length" class="table__no-data">
            <NoData :type="'offers'" />
          </div>
          <template v-else>
            <Offer
              v-for="(offer, index) in customerOffers"
              :key="offer.id"
              :offer="offer"
              :index="index"
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from "@/partials/NoData";
import Loading from "@/partials/Loading";
import Offer from "@/components/AccountDetails/Offer";
import { mapGetters } from "vuex";
export default {
  name: "OffersTable",

  components: {
    NoData,
    Loading,
    Offer,
  },
  computed: {
    ...mapGetters(["customerOffers", "customerDetails"]),

    costumerId(){
      return this.$store.getters.customerDetailsId;
    }
  },
  data() {
    return {
      detailsLoading: false,
      lastFetchedCustomerId: null,
    }
  },
  watch: {
    costumerId(newId) {
      if (newId && this.lastFetchedCustomerId !== newId) {
        this.fetchOffers();
      }
    }
  },
  async mounted() {
    if (this.lastFetchedCustomerId === this.costumerId) { 
      return;
    }

    if (this.costumerId) {
      await this.fetchOffers();
    }
  },
  methods: {
    async fetchOffers() {
      this.detailsLoading = true;
      try {
        await this.$store.dispatch("getCustomerOffers", this.costumerId);
        this.lastFetchedCustomerId = this.costumerId; 
      } finally {
        this.detailsLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
